/**
 * Regra de negócio: cada contato pode ter apenas uma conversa por canal (source).
 * Uma mesma pessoa pode ter uma conversa no WhatsApp e outra no Web, mas não duas no mesmo canal.
 */

/** Status da conversa para administração */
export const CONVERSATION_STATUS = {
  ATIVO: 'ativo',
  AGUARDANDO: 'aguardando',
  FINALIZADO: 'finalizado',
};

export const CONVERSATION_STATUS_LABELS = {
  [CONVERSATION_STATUS.ATIVO]: 'Ativo',
  [CONVERSATION_STATUS.AGUARDANDO]: 'Aguardando',
  [CONVERSATION_STATUS.FINALIZADO]: 'Finalizado',
};

/** Estágios do funil de conversa */
export const FUNNEL_STAGES = [
  { id: 'triagem', label: 'Triagem', color: 'bg-slate-50 border-slate-200', headerColor: 'bg-slate-100 text-slate-800' },
  { id: 'qualification', label: 'Qualificação', color: 'bg-sky-50 border-sky-200', headerColor: 'bg-sky-100 text-sky-800' },
  { id: 'proposal', label: 'Proposta', color: 'bg-amber-50 border-amber-200', headerColor: 'bg-amber-100 text-amber-800' },
  { id: 'negotiation', label: 'Negociação', color: 'bg-violet-50 border-violet-200', headerColor: 'bg-violet-100 text-violet-800' },
  { id: 'closed', label: 'Fechado', color: 'bg-emerald-50 border-emerald-200', headerColor: 'bg-emerald-100 text-emerald-800' },
];

export const INITIAL_CONVERSATIONS = [
  {
    id: 1,
    contact_id: 'ct-001-ana',
    name: "Ana Silva",
    avatar: "AS",
    source: "whatsapp",
    status: "online",
    conversationStatus: 'ativo',
    phone: "+55 11 99999-8888",
    email: "ana.silva@exemplo.com",
    teamId: 'sales',
    stage: 'qualification',
    assignedAiId: 'ai_qualifier',
    aiActive: true,
    lastMessage: "Olá! Sou a Juliana Castro. Como posso ajudar?",
    unread: 0,
    timestamp: "Agora",
    messages: [
      { id: 1, text: "Oi! Sou a Juliana, como posso te ajudar?", sender: "agent", isAi: true, aiName: 'Juliana Castro', time: "10:30" },
      { id: 2, text: "Quais os planos disponíveis?", sender: "customer", time: "10:42" }
    ]
  },
  {
    id: 2,
    name: "Carlos Tech",
    avatar: "CT",
    source: "web",
    status: "offline",
    conversationStatus: 'aguardando',
    phone: "+55 21 98888-7777",
    email: "carlos@tech.com",
    teamId: 'support',
    stage: 'proposal',
    assignedAiId: 'ai_support',
    aiActive: false,
    lastMessage: "Preciso de ajuda com a integração.",
    unread: 2,
    timestamp: "Ontem",
    messages: [
      { id: 1, text: "Preciso de ajuda com a integração.", sender: "customer", time: "18:00" }
    ]
  },
  {
    id: 5,
    contact_id: 'ct-003-pedro',
    name: "Pedro Lima",
    avatar: "PL",
    source: "whatsapp",
    status: "online",
    conversationStatus: 'ativo',
    phone: "+55 51 95555-4444",
    email: "pedro@contato.com",
    teamId: null,
    stage: 'triagem',
    assignedAiId: null,
    aiActive: false,
    lastMessage: "Oi, bom dia!",
    unread: 1,
    timestamp: "Agora",
    messages: [
      { id: 1, text: "Oi, bom dia!", sender: "customer", time: "11:00" }
    ]
  },
  {
    id: 3,
    name: "Maria Souza",
    avatar: "MS",
    source: "whatsapp",
    status: "online",
    conversationStatus: 'ativo',
    phone: "+55 31 97777-6666",
    email: "maria@empresa.com",
    teamId: 'sales',
    stage: 'negotiation',
    assignedAiId: 'ai_qualifier',
    aiActive: false,
    lastMessage: "Podemos fechar na próxima semana?",
    unread: 0,
    timestamp: "2h",
    messages: [
      { id: 1, text: "Oi! Gostaria de conhecer os planos.", sender: "customer", time: "09:00" },
      { id: 2, text: "Enviamos a proposta por e-mail.", sender: "agent", isAi: false, time: "09:15" }
    ]
  },
  {
    id: 4,
    name: "João Ferreira",
    avatar: "JF",
    source: "web",
    status: "offline",
    conversationStatus: 'finalizado',
    phone: "+55 41 96666-5555",
    email: "joao@startup.io",
    teamId: 'sales',
    stage: 'closed',
    assignedAiId: 'ai_qualifier',
    aiActive: false,
    lastMessage: "Contrato assinado!",
    unread: 0,
    timestamp: "Ontem",
    messages: [
      { id: 1, text: "Perfeito, vamos fechar!", sender: "customer", time: "16:00" }
    ]
  }
];
